import React from "react"

import Logo from "./../../components/Logo"
import Waves from "./../../components/Waves"

import {
  FooterWrapper,
  List,
  Item,
  Heading,
  Text,
  Mail,
  MenuLink,
  Bottom,
  Copyright,
  StyledLink,
  CopyrightLink,
  Line,
  Credit,
} from "./styles.js"

const Footer = () => (
  <FooterWrapper>
    <List>
      <Item>
        <Logo />
      </Item>
      <Item>
        <Heading>Contact</Heading>
        <Mail href="mailto:info@20medtx.com" target="_blank">
          Info@20medtx.com
        </Mail>
        <Mail href="mailto:careers@20medtx.com" target="_blank">
          Careers@20medtx.com
        </Mail>
        <Text>Office: +31 53 489 99 39</Text>
      </Item>
      <Item>
        <Heading>LEIDEN ADDRESS</Heading>
        <Text>Galileiweg 8</Text>
        <Text>2333BD, Leiden</Text>
        <Text>The Netherlands</Text>
      </Item>
      <Item>
        <Heading>ENSCHEDE ADDRESS</Heading>
        <Text>Calslaan 17</Text>
        <Text>7522MJ, Enschede</Text>
        <Text>The Netherlands</Text>
      </Item>
      <Item>
        <Heading>Menu</Heading>
        <MenuLink to="/about-us/company-history/">Company History</MenuLink>
        <MenuLink to="/about-us/leadership/">Leadership</MenuLink>
        <MenuLink to="/technology/">Technology</MenuLink>
        <MenuLink to="/technology/nanogel-drug-delivery-platform/">
          Nanogel Drug Delivery Platform
        </MenuLink>
        <MenuLink to="/technology/nanogels-in-drug-development/">
          Nanogels in Drug Development
        </MenuLink>
        <MenuLink to="/therapeutic-applications/">
          Therapeutic applications
        </MenuLink>
        <MenuLink to="/partnering/partnership-opportunities/">
          Partnership opportunities
        </MenuLink>
        <MenuLink to="/projects/">Projects</MenuLink>
        <MenuLink to="/news/">News</MenuLink>
        <MenuLink to="/contact/">Contact</MenuLink>
      </Item>
    </List>
    <Bottom>
      <Waves />
      <Copyright>
        <CopyrightLink to="/privacy/">Privacy</CopyrightLink>
        <Line />
        <Credit>
          Credit made by{" "}
          <StyledLink href="https://askphill.com" target="_blank">
            Ask Phill
          </StyledLink>
        </Credit>
      </Copyright>
    </Bottom>
  </FooterWrapper>
)

export default Footer
